import { ManagementApiService } from 'src/app/services';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OrganizationDataService } from 'src/app/services/organization-data.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { OrganizationUserModel, UserLicense } from 'src/app/Modules/management/models/organization/organization-user.model';
import { Organization, profileContactModel, SecurityLevels } from 'src/app/Modules/management/models/organization/organization.model';
import { requireCheckboxesToBeCheckedValidator } from 'src/app/Modules/idms/core/atleastOneChecked.validator';
import { LicenseType } from 'src/app/Modules/management/models/organization/license-type.model';
import { PermissionHierarchy } from 'src/app/Modules/management/models/organization/security-role-permission.model';

@Component({
    selector: 'app-edit-user-modal',
    templateUrl: './edit-user-modal.component.html',
    styleUrls: ['./edit-user-modal.component.scss'],
    standalone: false,
})
export class EditUserModalComponent implements OnInit, OnDestroy {
    @Input() organizationUser: OrganizationUserModel;
    @Input() userTypes;
    @Input() userSecurityLevels: SecurityLevels[];
    @Input() licenseType;
    @Input() modalMode;
    @Input() activeOrganization: Organization;

    editUserForm: UntypedFormGroup;
    userRoleObject: PermissionHierarchy[];
    licenseTypeName: string;
    updatedUser: OrganizationUserModel = {
        userId: '',
        organisationID: '',
        license: new UserLicense(),
        securityLevelID: '',
        securityRoleID: '',
        //securityLevel: new SecurityLevels,
        profileContact: new profileContactModel(),
        securityRoles: [],
        organisation: new Organization(),
    };
    userFormData: FormData;
    isSecurityRoleChanged: boolean;
    CONST_ORGANIZATION_USER: string;
    disableOptions: boolean = false;
    currentDate: Date;
    currentOrganizationId: string;
    constructor(
        private ngbActiveModal: NgbActiveModal,
        private formBuilder: UntypedFormBuilder,
        private organizationDataService: OrganizationDataService,
        private managementApiService: ManagementApiService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private customToastServiceService: CustomToastService
    ) {
        this.CONST_ORGANIZATION_USER = 'Organisation User';
        this.isSecurityRoleChanged = false;
        this.currentDate = new Date();
    }

    ngOnInit(): void {
        if (this.modalMode == 'View') {
            this.disableOptions = true;
        }
        this.initUserFormControls();
        this.userRoleObject = this.organizationDataService.getUserSecurityRoles();
        this.userRoleObject = this.organizationDataService.filterSecurityRolesByLicense(this.userRoleObject, this.activeOrganization);
        this.userRoleObject = this.organizationDataService.getFilterSecurityRoleForUser(this.userRoleObject, this.organizationUser);
        this.userRoleObject = [...new Set(this.userRoleObject)];
    }

    updateUser() {
        this.getUserFormControlsValue();
        let userPayload = this.createUserFormDataObject();
        this.ngxUiLoaderService.start();
        this.managementApiService.updateOrganizationUser(userPayload).subscribe(
            (response) => {
                if (response.success === true) {
                    this.customToastServiceService.successToast('User updated successfully', 'Success');
                } else {
                    this.customToastServiceService.errorToast(response.message);
                }
                this.ngbActiveModal.close(true);
                this.ngxUiLoaderService.stop();
            },
            (error) => {
                this.ngxUiLoaderService.stop();
                //here toastr will be added
            }
        );
    }

    createUserFormControls() {
        this.editUserForm = this.formBuilder.group({
            user_email: new UntypedFormControl('', [Validators.required, Validators.email]),
            user_first_name: new UntypedFormControl('', [Validators.required]),
            user_last_name: new UntypedFormControl('', Validators.required),
            user_role: new UntypedFormControl('', [Validators.required]),
            user_type: new UntypedFormControl('', []),
            licenseGroup: new UntypedFormGroup(
                {
                    idms_license: new UntypedFormControl(true, [Validators.required]),
                    informate_license: new UntypedFormControl(false, [Validators.required]),
                    ca_license: new UntypedFormControl(false, [Validators.required]),
                },
                requireCheckboxesToBeCheckedValidator()
            ),
            license_type: new UntypedFormControl('', [Validators.required]),
            license_startDate: new UntypedFormControl(null, []),
            license_endDate: new UntypedFormControl(null, []),
            license_days: new UntypedFormControl('', []),
        });
    }

    initUserFormControls() {
        let licenseTypeIndex = this.organizationUser.license.instanceTypeIndex;
        let ice_license = (licenseTypeIndex & 1) === 1;
        let idms_license = (licenseTypeIndex & 2) === 2;
        let ca_license = (licenseTypeIndex & 4) === 4;
        let noOfDays = 0;
        if (this.organizationUser.license.licenseType.name === 'Timed') {
            let startDate = new Date(this.organizationUser.license.startDate);
            let endDate = new Date(this.organizationUser.license.endDate);
            let totalMsPerDay = 1000 * 60 * 60 * 24;
            let startDay = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
            let endDay = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
            noOfDays = Math.floor((endDay - startDay) / totalMsPerDay);
        }
        this.editUserForm = this.formBuilder.group({
            user_email: new UntypedFormControl(this.organizationUser.profileContact.email, [Validators.required, Validators.email]),
            user_first_name: new UntypedFormControl(this.organizationUser.profileContact.firstName, [Validators.required]),
            user_last_name: new UntypedFormControl(this.organizationUser.profileContact.lastName, Validators.required),
            // user_role: new FormControl(this.organizationUser.securityLevel.name, [Validators.required]),
            user_type: new UntypedFormControl(this.organizationUser.securityRoles[0].securityRole.securityRoleId, []),
            licenseGroup: new UntypedFormGroup(
                {
                    idms_license: new UntypedFormControl(idms_license, [Validators.required]),
                    informate_license: new UntypedFormControl(ice_license, [Validators.required]),
                    ca_license: new UntypedFormControl(ca_license, [Validators.required]),
                },
                requireCheckboxesToBeCheckedValidator()
            ),
            license_type: new UntypedFormControl(this.organizationUser.license.licenseType.name, [Validators.required]),
            license_startDate: new UntypedFormControl(this.organizationUser.license.startDate, []),
            license_endDate: new UntypedFormControl(this.organizationUser.license.endDate, []),
            license_days: new UntypedFormControl(noOfDays ? noOfDays : '', noOfDays ? Validators.required : []),
        });
        this.licenseTypeName = this.organizationUser.license.licenseType.name;
        this.editUserForm.get('user_type').valueChanges.subscribe((value) => {
            this.isSecurityRoleChanged = true;
        });
        this.editUserForm.get('license_startDate').valueChanges.subscribe((startDate: Date) => {
            if (startDate) {
                this.editUserForm.get('license_endDate').setValue(new Date(this.setDate(startDate)));
            }
        });
        this.handleLicenseTypeValidation();
    }

    handleLicenseTypeValidation() {
        // this.userRoleObject
        this.editUserForm.get('license_type').valueChanges.subscribe((option: any) => {
            if (option === 'Renewal') {
                this.editUserForm.get('license_startDate').setValidators([Validators.required]);
                this.editUserForm.get('license_endDate').setValidators([Validators.required]);
                this.editUserForm.get('license_days').clearValidators();
                this.editUserForm.get('license_days').reset();
            } else if (option === 'Timed') {
                this.editUserForm.get('license_days').setValidators([Validators.required]);
                this.editUserForm.get('license_startDate').clearValidators();
                this.editUserForm.get('license_endDate').clearValidators();
                this.editUserForm.get('license_startDate').reset();
                this.editUserForm.get('license_endDate').reset();
            } else if (option === 'Perpetual' || option === 'On Hold') {
                this.editUserForm.get('license_startDate').clearValidators();
                this.editUserForm.get('license_endDate').clearValidators();
                this.editUserForm.get('license_days').clearValidators();
                this.editUserForm.get('license_startDate').reset();
                this.editUserForm.get('license_endDate').reset();
                this.editUserForm.get('license_days').reset();
            }
            this.editUserForm.get('license_startDate').updateValueAndValidity();
            this.editUserForm.get('license_endDate').updateValueAndValidity();
            this.editUserForm.get('license_days').updateValueAndValidity();
        });
    }

    getUserFormControlsValue() {
        let userProfileContact = new profileContactModel();
        let userLicense = new UserLicense();
        let userLicenseType = new LicenseType();

        this.updatedUser.userId = this.organizationUser.userId;
        this.updatedUser.organisationID = this.currentOrganizationId;
        userProfileContact.profileContactId = this.organizationUser.profileContact.profileContactId;
        userProfileContact.firstName = this.editUserForm.get('user_first_name').value;
        userProfileContact.lastName = this.editUserForm.get('user_last_name').value;
        userProfileContact.email = this.editUserForm.get('user_email').value;
        userLicenseType.licenseTypeId = this.getLicenseTypeId(this.editUserForm.get('license_type').value);
        if (this.editUserForm.get('license_type').value !== 'On Hold' && this.editUserForm.get('license_type').value !== 'Perpetual') {
            if (this.editUserForm.get('license_type').value == 'Timed') {
                let startDate;
                let tempStartDate;
                if (this.organizationUser.license.startDate) {
                    startDate = new Date(this.organizationUser.license.startDate);
                    tempStartDate = new Date(this.organizationUser.license.startDate);
                } else {
                    startDate = new Date();
                    tempStartDate = new Date();
                }
                let endDate = new Date(tempStartDate.setDate(tempStartDate.getDate() + this.editUserForm.get('license_days').value));
                userLicense.startDate = startDate.toDateString();
                userLicense.endDate = endDate.toDateString();
            } else {
                userLicense.startDate = new Date(this.editUserForm.get('license_startDate').value).toDateString();
                userLicense.endDate = new Date(this.editUserForm.get('license_endDate').value).toDateString();
            }
        }
        //this.updatedUser.securityLevelID = this.userSecurityLevels.find( (item)=> item.name.replace(" ","").toLocaleLowerCase() == this.CONST_ORGANIZATION_USER.replace(" ","").toLocaleLowerCase()).securityLevelId;
        this.updatedUser.securityRoleID = this.editUserForm.get('user_type').value;

        let instanceTypeIndex = 0;
        if (this.editUserForm.get('licenseGroup').get('informate_license').value) {
            instanceTypeIndex += 1;
        }
        if (this.editUserForm.get('licenseGroup').get('idms_license').value) {
            instanceTypeIndex += 2;
        }
        if (this.editUserForm.get('licenseGroup').get('ca_license').value) {
            instanceTypeIndex += 4;
        }
        userLicense.instanceTypeIndex = instanceTypeIndex;
        userLicense.licenseType = userLicenseType;
        this.updatedUser.profileContact = userProfileContact;
        this.updatedUser.license = userLicense;
    }

    // helper method to set the end date
    setDate(customDate: Date) {
        let date = new Date(customDate);
        date.setDate(date.getDate() + 365);
        return date.toDateString();
    }

    //helper method to find the licenseType id
    getLicenseTypeId(licenseName: string): string {
        let licenseTypeId = '';
        this.licenseType.forEach((license) => {
            if (license.name === licenseName) {
                licenseTypeId = license.licenseTypeId;
            }
        });
        return licenseTypeId;
    }

    //helper method to find the security level
    getSecurityRoleId(securityLevelName: string): string {
        let securityRoleId = '';
        this.userSecurityLevels.forEach((securityObj) => {
            if (securityObj.name === securityLevelName) {
                securityRoleId = securityObj.securityLevelId;
            }
        });
        return securityRoleId;
    }

    getUserTypeId(userTypeName: string) {
        let userTypeId = '';
        this.userRoleObject.forEach((securityObj) => {
            if (securityObj.name === userTypeName) {
                userTypeId = securityObj.securityRoleId;
            }
        });
        return userTypeId;
    }

    // * Filter security roles
    filterSecurityRoles(organization: Organization) {
        if (!organization) return;

        const clonedUserRoleObject = JSON.parse(JSON.stringify(this.userRoleObject.slice()));
    }

    closeAddUSerModal() {
        this.ngbActiveModal.close(false);
    }

    createUserFormDataObject() {
        this.userFormData = new FormData();
        this.userFormData.append('user[UserID]', this.updatedUser.userId);
        this.userFormData.append('user[OrganisationID]', this.updatedUser.organisationID);
        this.userFormData.append('user[ProfileContact][ProfileContactId]', this.updatedUser.profileContact.profileContactId);
        this.userFormData.append('user[ProfileContact][Email]', this.updatedUser.profileContact.email);
        this.userFormData.append('user[ProfileContact][FirstName]', this.updatedUser.profileContact.firstName);
        this.userFormData.append('user[ProfileContact][LastName]', this.updatedUser.profileContact.lastName);
        this.userFormData.append('user[License][LicenseTypeId]', this.updatedUser.license.licenseType.licenseTypeId);
        this.userFormData.append('user[License][LicenseId]', this.organizationUser.license.licenseId);
        //this.userFormData.append("user[SecurityLevelID]",this.updatedUser.securityLevelID);
        // this.userFormData.append("user[SecurityRoles][0]",this.updatedUser.securityRoleID);
        if (this.isSecurityRoleChanged) {
            this.userFormData.append('user[SecurityRoles][1][SecurityRoleId]', this.updatedUser.securityRoleID);
            this.userFormData.append('user[SecurityRoles][0][Active]', false as unknown as Blob);
            this.userFormData.append('user[SecurityRoles][0][UserSecurityRoleId]', this.organizationUser.securityRoles[0].userSecurityRoleId);
        }
        this.userFormData.append('user[License][InstanceTypeIndex]', this.updatedUser.license.instanceTypeIndex as unknown as Blob);
        if (this.editUserForm.get('license_type').value !== 'On Hold' && this.editUserForm.get('license_type').value !== 'Perpetual') {
            this.userFormData.append('user[License][StartDate]', this.updatedUser.license.startDate);
            this.userFormData.append('user[License][EndDate]', this.updatedUser.license.endDate);
        }
        return this.userFormData;
    }

    numberOnly(event: any): boolean {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    ngOnDestroy(): void {}
}
